import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "../../assets/css/Profile.css";
import SideBar from "../../Components/SideBar/SideBar";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import TopBar from "../../Components/SideBar/TopBar";
import { arrow, ProBox } from "../../constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Signup from "./../Auth/Signup";
import {
  cancelMemberShipApiCall,
  GetCustomerMemberShip,
  updateCSAMembership,
} from "../../network/Network";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";

function CSAmemberdetail() {
  const Token = useSelector((state) => state.AuthReducer.token);
  const location = useLocation();
  const param = useParams();
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);

  const [state, setState] = useState(null);
  const [newFile, setNewFile] = useState("");
  const [fileupload, setFileupload] = useState("");
  const [uploadLoading, setUploadLoading] = useState(false);
  const [editState, setEditState] = useState(false);
  const [passLoading, setPassLoading] = useState(false);

  const [firstName, setFirstName] = useState("John");
  const [lastName, setLastName] = useState("Doe");
  const [phone, setPhone] = useState("0123432432");
  const [editLoading, setEditLoading] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [passwordChange, setPasswordChange] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleImageUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setNewFile(file);
      setFileupload(reader.result);
    };
    reader.readAsDataURL(file);
    setUploadLoading(true);
  };

  const getMemberShipCurrentData = () => {
    setLoading(true);
    GetCustomerMemberShip(Token, param.id)
      .then((res) => {
        setState(res?.data?.response?.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getMemberShipCurrentData();
  }, []);

  const updateMembership = (item) => {
    setLoading(true);
    let sendData = {
      membership_id: state?.membership_id,
      csa_price_id: item?.id,
      csa_product_id: item?.csa_product_id,
    };
    updateCSAMembership(Token, sendData)
      .then((res) => {
        setLoading(false);
        toast.success("CSA membership has been updated successfully");
        getMemberShipCurrentData();
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const cancelMemberShip = (e) => {
    let sendData = {
      membership_id: state?.membership_id,
    };
    cancelMemberShipApiCall(Token, sendData)
      .then((res) => {
        toast.success(`Your CSA membership cancelled at the day end`);
        navigate("/");
      })
      .catch((err) => {});
  };

  return (
    <>
      <Header />

      {/* <!-- Universal Banner Sec End Here --> */}
      <section className="profile">
        <div className="container">
          <div className="row profile-row">
            <SideBar
              uploadLoading={uploadLoading}
              fileupload={fileupload}
              handleImageUpload={handleImageUpload}
            />
            <div className="col-lg-9">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <TopBar />
                  <div className="row"></div>
                  <div className="row info-profile">
                    {loading ? (
                      <div className="col-lg-12 p-4">
                        <Skeleton count={8} />
                      </div>
                    ) : (
                      <div className="col-md-12 rightSide-profile">
                        <div className="row mb-4">
                          <div className="col-lg-6">
                            <div className="Accounts">
                              <h5>My Membership</h5>
                            </div>
                            <p className="familyMember-Title">CSA Membership</p>
                            <p className="expiryBtn">
                              Create date: {state?.created_at.slice(0, 10)}
                            </p>{" "}
                            <p className="expiryBtn">
                              Renewal type : {state?.csa_product_price?.type}
                            </p>
                            <p className="expiryBtn">
                              Status :{" "}
                              {state?.subscription_status.replaceAll("_", " ")}
                            </p>
                          </div>
                          <div className="col-lg-6">
                            <div className="familyMember-Title">
                              {state?.csa_product?.csa_product_price
                                .filter((item) => {
                                  return (
                                    item.type != state?.csa_product_price?.type
                                  );
                                })
                                .map((item) => {
                                  return (
                                    <button
                                      onClick={() => {
                                        updateMembership(item);
                                      }}
                                      className="btn cancel-memberBtn3"
                                    >
                                      Update to {item?.type} &nbsp;&nbsp;
                                      <img
                                        src={arrow}
                                        alt=""
                                        className="image-fluid"
                                      />
                                    </button>
                                  );
                                })}

                              <button
                                onClick={cancelMemberShip}
                                disabled={
                                  state?.subscription_status ==
                                  "cancel_at_period_end"
                                }
                                className="btn cancel-memberBtn cancel-memberBtn5"
                              >
                                Cancel Membership &nbsp;&nbsp;
                                <img
                                  src={arrow}
                                  alt=""
                                  className="image-fluid"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row csa_Membership">
                          <div className="productDetails_section">
                            <div className="productDiv">
                              <img
                                className="img_membership_csa_View"
                                src={`${ImageUrlRedux?.csa_image_url}/${state?.csa_product?.image}`}
                                alt="pro-image"
                              />
                              <div className="productDiv_text">
                                <h4>{state?.csa_product?.title}</h4>
                                <p>{state?.csa_product?.description}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default CSAmemberdetail;
